import { Action } from '@ngrx/store';
import { AdditionalService, Order } from '@cemex-core/cmx-api';

export enum OneClickAdditionalServicesActionTypes {
  LOAD_ADITIONAL_SERVICES = '[One Click] Load additional services',
  LOAD_ADITIONAL_SERVICES_COMPLETE = '[One Click] Load additional services completed',
  SELECT_ADITIONAL_SERVICES = '[One Click] Select additional services',
  RESET = '[One Click] additional services reset',
}

export class OneClickLoadAdditionalServicesAction implements Action {
  readonly type = OneClickAdditionalServicesActionTypes.LOAD_ADITIONAL_SERVICES;

  constructor(public payload: Order) {}
}

export class OneClickLoadAdditionalServicesCompleteAction implements Action {
  readonly type = OneClickAdditionalServicesActionTypes.LOAD_ADITIONAL_SERVICES_COMPLETE;

  constructor(public payload: AdditionalService[]) {}
}

export class OneClickSelectAdditionalServicesAction implements Action {
  readonly type = OneClickAdditionalServicesActionTypes.SELECT_ADITIONAL_SERVICES;

  constructor(public payload: AdditionalService) {}
}

export class OneClickResetAdditionalServicesAction implements Action {
  readonly type = OneClickAdditionalServicesActionTypes.RESET;

  constructor(public payload: any) {}
}

export type OneClickAdditionalServicesActions =
  | OneClickLoadAdditionalServicesAction
  | OneClickLoadAdditionalServicesCompleteAction
  | OneClickSelectAdditionalServicesAction
  | OneClickResetAdditionalServicesAction;
